import queryString from 'query-string';
import {
  getCampaignType,
  campaignId,
  campaignStatus,
  CAMPAIGN_TYPE,
} from 'utils/campaign';
import env from 'utils/env';
import request from './request';

// eslint-disable-next-line import/prefer-default-export
export function getCampaign(campaignType, loggedInUser = true) {
  const type = campaignType || getCampaignType();
  const api =
    !loggedInUser && type === CAMPAIGN_TYPE.shop
      ? env.publicAceApi // only for Intro Product Shop
      : env.aceApi;
  const queryParams = {
    type,
    ...(campaignId && { campaignId }),
    ...(campaignStatus && { campaignStatus }),
  };

  const requestUrl = `${api}/1/campaigns?${queryString.stringify(queryParams)}`;
  return request(requestUrl);
}

export function getCustomizeCampaignState() {
  const requestUrl = `${env.customize}/customize/self/campaign-state`;
  return request(requestUrl);
}
